import config from '@/config';

export const theme = {
	calendar: {
		width: '340px',
		maxWidth: '100vw',
		legend: {
			height: '45px'
		},
		shadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		colors: {
			text: {
				primary: '#333',
				highlight: '#fff'
			},
			background: {
				primary: '#fff',
				highlight: config.BRAND_NAME === 'PlayUp' ? '#00F181' : '#11B2B7',
				hover: '#eee'
			},
			border: '#eee'
		},
		font: {
			regular: '1.1em',
			large: '37em'
		},
		grid: {
			disabledOpacity: '.35',
			outsiderOpacity: '.6'
		}
	}
};
